export class Identificador {
  cdMsgemRetorno?: string;
  dsMsgemRetorno?: string;
  nuCpfCnpj: string;
  cdTipoCpfCnpj: string;
  cdChaveForte: string;
  cdChaveFraca: string
  nuContrato?: string;
  nuChassi: string;
  dtDiaVencimento: string;
  dtNascimento?: string;
  qtParcela?: string;
  dtAnoFabricacao?: string;
  dtAnoModelo?: string;
  vrSenha: string;
  vrConfirmacaoSenha: string;
  nuDdd?:string ;
  nuCelular?: string;
  nuCTRL?: string;
  cdMidia: number;
  token?: string;
  keyCaptcha?: string;
  txtCaptcha?: string;
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/identificador.ts